import { bindDataAndCallFunctions } from "./bindDataAndCallFunctions.js";
import { defaultWidth, defaultHeight } from "../defaults.js";
/**
 * Draws labels for nodes.
 */
const drawLabel = (container, data, onDrag) => {
  bindDataAndCallFunctions(
    container.selectAll("text.label"),
    [data],
    (enter) =>
      enter
        .append("text")
        .classed("label", true)
        .attr("x", (d) => d.labelPosition?.x ?? d.size.width + defaultWidth / 2) // Default to the right of the container
        .attr("y", (d) => d.labelPosition?.y ?? d.size.height / 2) // Default to vertically centered
        .attr("dy", defaultHeight / 4) // Adjust vertical alignment
        .attr("text-anchor", "start") // Align text to the left of the x position
        .attr("font-size", "12px")
        .text((d) => d.label || "")
        .call(onDrag),
    (update) =>
      update
        .attr("x", (d) => d.labelPosition?.x ?? d.size.width + 10) // Update x dynamically
        .attr("y", (d) => d.labelPosition?.y ?? d.size.height / 2) // Update y dynamically
        .text((d) => d.label || ""),
    (exit) => exit.remove()
  );
};

export { drawLabel };
